import { AlertEventsSearchFiltersState } from "@idw-types/state/alert-events-state";
import { FormattedAlertEventHistory } from "@idw-types/data/alert-event-history";

export enum AlertEventsActionTypes {
    SET_ALERT_EVENTS_SEARCH_FILTERS = "SET_ALERT_EVENTS_SEARCH_FILTERS",
    SET_ALERT_EVENTS_SEARCH_RESULTS_LOADING = "SET_ALERT_EVENTS_SEARCH_RESULTS_LOADING",
    SET_ALERT_EVENTS_SEARCH_RESULTS = "SET_ALERT_EVENTS_SEARCH_RESULTS"
}

type SetAlertEventsSearchFiltersAction = {
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_FILTERS;
    payload: { searchFilters: AlertEventsSearchFiltersState };
};

export const setAlertEventsSearchFilters = (searchFilters: AlertEventsSearchFiltersState): SetAlertEventsSearchFiltersAction => ({
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetAlertEventsSearchResultsLoadingAction = {
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setAlertEventsSearchResultsLoading = (isLoading: boolean): SetAlertEventsSearchResultsLoadingAction => ({
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetAlertEventsSearchResultsAction = {
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS;
    payload: { alertEvents: Array<FormattedAlertEventHistory> };
};

export const setAlertEventsSearchResults = (alertEvents: Array<FormattedAlertEventHistory>): SetAlertEventsSearchResultsAction => ({
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS,
    payload: { alertEvents }
});

export type AlertEventsActions =
    SetAlertEventsSearchFiltersAction |
    SetAlertEventsSearchResultsLoadingAction |
    SetAlertEventsSearchResultsAction